import "./App.css";
import { Home } from "./Home";
import { Cards } from "./Cards";
import { Routes, Route } from "react-router-dom";
import { BrowserRouter, NavLink } from "react-router-dom";
//import { Deckbuilder } from "./Deckbuilder";
import { Deckbuilder } from "./Deckbuilder";
import { LeagueTracker } from "./components/LeagueTracker";
import { StoreLocator } from "./components/StoreLocator";
import React, { useState, useEffect } from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { variables } from "./Variables";

function App() {
  const [cardData, setCardData] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const baseUrl = variables.API_URL;

  useEffect(() => {
    const grabData = async () => {
      axios
        .get(baseUrl)
        .then((res) => {
          setCardData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log({ msg: err.message });
        });
    };
    grabData();
  }, []);

  return (
    <BrowserRouter>
      <div className="App .container-fluid colorBG">
        <div className="wide100per colorBGBlack">
          <img
            src="../assets/images/background/VariaLogo.png"
            className="imgNoRadius h10vh"
          ></img>
        </div>

        <nav className="navbar navbar-expand-sm bg-dark navbar-dark">
          <ul className="nav navbar-nav">
            <li className="nav-item- m-1">
              <NavLink className="btn btn-dark btn-outline-warning" to="/">
                Home
              </NavLink>
            </li>
            <li className="nav-item- m-1">
              <NavLink className="btn btn-dark btn-outline-warning" to="/cards">
                Cards
              </NavLink>
            </li>
            <li className="nav-item- m-1">
              <NavLink
                className="btn btn-dark btn-outline-warning"
                to="/Deckbuilder"
              >
                Deck Builder
              </NavLink>
            </li>
            <li className="nav-item- m-1">
              <NavLink
                className="btn btn-dark btn-outline-warning"
                to="/components/StoreLocator"
              >
                Store Locator
              </NavLink>
            </li>
          </ul>
        </nav>

        <Routes>
          <Route path="/" element={<Home />} />
          {isLoading ? (
            "Loading..."
          ) : (
            <Route path="/Cards" element={<Cards />} />
          )}
          <Route path="/Deckbuilder" element={<Deckbuilder />} />
          <Route path="/components/StoreLocator" element={<StoreLocator />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
